/**
 * Customer pizza creations (UGC) moderation. Talks to the /creations group,
 * which is the admin.php "Pizza Creations Moderation" tab moved into Connect.
 * Non-namespaced like every other module here.
 */
const notifyError = (commit, message) =>
  commit("NOTIFICATION_MESSAGE", { status: -1, title: "Creations", message });

const form = (obj) => {
  const p = new URLSearchParams();
  Object.keys(obj).forEach((k) => p.append(k, obj[k]));
  return p;
};

const state = () => ({
  rows: [],
  total: 0,
  loaded: false,
  error: "",
  detail: null, // { creation, groups }
});

const mutations = {
  RESET_CREATIONS(s) { Object.assign(s, state()); },
  SET_CREATIONS(s, { rows, total }) { s.rows = rows || []; s.total = total || 0; s.loaded = true; s.error = ""; },
  SET_CREATIONS_ERROR(s, m) { s.error = m; s.loaded = true; },
  SET_CREATION_DETAIL(s, v) { s.detail = v; },
};

const VERDICT_LABEL = { clean: "approved", flagged: "flagged", hidden: "hidden", deleted: "deleted" };

const actions = {
  /** The first load shows the global loader; filter, page and search changes pass silent so the panel stays usable. */
  async getCreations({ commit }, arg) {
    const params = arg && arg.params ? arg.params : arg;
    const silent = !!(arg && arg.silent);
    if (!silent) commit("LOADING", { isActiveStatus: true });
    try {
      const { data } = await window.$http.axios.get("creations/list", { params });
      if (data.status) commit("SET_CREATIONS", data);
      else { notifyError(commit, data.message); commit("SET_CREATIONS_ERROR", data.message || "The server refused the request."); }
    } catch (e) {
      notifyError(commit, "Could not load creations.");
      commit("SET_CREATIONS_ERROR", "Could not reach the creations service. It may not be installed on this server yet.");
    } finally {
      if (!silent) commit("LOADING", { isActiveStatus: false });
    }
  },

  async getCreationDetail({ commit }, id) {
    commit("SET_CREATION_DETAIL", null);
    try {
      const { data } = await window.$http.axios.get("creations/detail", { params: { id } });
      if (data.status) commit("SET_CREATION_DETAIL", { creation: data.creation, groups: data.groups || [] });
      else notifyError(commit, data.message);
    } catch (e) {
      notifyError(commit, "Could not load the creation.");
    }
  },

  async setCreationVerdict({ commit }, { id, verdict, reason }) {
    try {
      const { data } = await window.$http.axios.post("creations/verdict", form({ id, verdict, reason: reason || "" }));
      if (data.status) { commit("NOTIFICATION_MESSAGE", { status: 1, title: "Creations", message: "Creation #" + id + " " + (VERDICT_LABEL[verdict] || verdict) + "." }); return true; }
      notifyError(commit, data.message); return false;
    } catch (e) { notifyError(commit, "Could not update the creation."); return false; }
  },

  async setCreationPhotoVerdict({ commit }, { id, verdict, reason }) {
    try {
      const { data } = await window.$http.axios.post("creations/photo-verdict", form({ id, verdict, reason: reason || "" }));
      if (data.status) { commit("NOTIFICATION_MESSAGE", { status: 1, title: "Creations", message: (verdict === "clean" ? "Photo approved" : "Photo flagged") + " on #" + id + "." }); return true; }
      notifyError(commit, data.message); return false;
    } catch (e) { notifyError(commit, "Could not update the photo."); return false; }
  },
};

export default { state, mutations, actions };
